let currentRoute = null;

export const navigate = (path) => {
  if (window.location.pathname === path) return;
  history.pushState(null, '', path);
  window.dispatchEvent(new CustomEvent('routechange', { detail: path }));
};

export const getCurrentPath = () => window.location.pathname || '/';
